module.exports = __webpack_public_path__ + "static/img/landing.7a7623f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/ftb/landing.png
// module id = 7+6B
// module chunks = 0